import View from "../view/view";
import {EntityType} from "../../gd/const/item";
import ErrorProto from "../../gd/validation/error";
import ErrorFieldRequired from "../../gd/validation/error-field-required";
import {ViewScope} from "../view/@const";

export default class Report<SettingsClass=any> extends View {

    public icon         : string = "i5-reports"
    public description  : string
    public autoGenerate : boolean

    constructor(data: any) {
        super(data, data.type, EntityType.REPORT_VIEW);

        // id, name & type init in super
        this.description  = data.description;
        this.autoGenerate = _.get(data, "autoGenerate", true);

    }

    validate():ErrorProto[] | null  {
        const errors : any[] = []

        if (!this.name) errors.push(new ErrorFieldRequired(gd.fields.reportFields.name))

        if (_.isEmpty(errors)) return null
        else return errors
    }

    async getData():Promise<any> {

        if (this.isSavedView) {
            return this.savedView!.data
        }

        return await this.loadData()
    }

    async loadData():Promise<any> {
        throw Error("Not implemented #3904584575")
    }

    public applyProjectScope(projectId:ID) {
        // used when we deal with project reports
        // sets correct scope AND updates settings -
        // to select data from specified project only where needed
        this.scope = ViewScope.PROJECT

        // should be redefined in children
        // throw Error("Not implemented #90482730f")
    }

    get isProjectReport() {
        return this.scope === ViewScope.PROJECT
    }

    toJSON():JSONObject {

        return {
            id           : this.id,
            type         : this.type,
            name         : this.name,
            description  : this.description,
            scope        : this.scope,

            // @ts-ignore
            settings     : this.settings.toJSON() // ne poimu pochemyu TS error
        }
    }
}
